export class Nota {
    idPostit: string;
    comentario: string;
    fecha: string;
}



// WEBPACK FOOTER //
// ./src/models/nota.ts